export default class Form {
    form;

    constructor(form) {
        this.form = form;
    }

    getFormFields() {
        return this.form.querySelectorAll('input, textarea, select');
    }

    getFieldsObject() {
        let inputs = this.getFormFields();
        let result = {};

        Array.from(inputs).forEach((input) => {
            let inputName = input.name;

            result[inputName] = input.value;
        });

        return result;
    }
}